import { render, staticRenderFns } from "./EventCreateContainer.vue?vue&type=template&id=0cd1bc1d&scoped=true"
import script from "./EventCreateContainer.vue?vue&type=script&lang=js"
export * from "./EventCreateContainer.vue?vue&type=script&lang=js"
import style0 from "./EventCreateContainer.vue?vue&type=style&index=0&id=0cd1bc1d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd1bc1d",
  null
  
)

export default component.exports